import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getVenditeContatti } from '../../services/venditeContattiService';

const monthLabels = ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];

export default function VenditeContattiCard() {
  const { id } = useParams();
  const [months, setMonths] = useState(6);
  const [data, setData] = useState([]);
  const [tooltip, setTooltip] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await getVenditeContatti(id, months);
        setData(res);
      } catch (err) {
        console.error('Errore recupero vendite/contatti dashboard', err);
      }
    }
    fetchData();
  }, [id, months]);

  const totalContatti = data.reduce((sum, d) => sum + Number(d.contatti), 0);
  const totalVendite = data.reduce((sum, d) => sum + Number(d.vendite), 0);
  const conversion = totalContatti > 0 ? ((totalVendite / totalContatti) * 100).toFixed(1) : '0';

  const maxVal = Math.max(...data.map(d => Math.max(d.contatti, d.vendite)), 0);
  const step = maxVal > 0 ? Math.ceil(maxVal / 4) : 1;
  const labels = [step * 4, step * 3, step * 2, step, 0];
  const scale = maxVal > 0 ? 240 / (step * 4) : 0; // 240px max height

  const handleEnter = (e, item) => {
    setTooltip({
      month: monthLabels[Number(item.month.split('-')[1]) - 1],
      contatti: item.contatti,
      vendite: item.vendite,
      x: e.clientX,
      y: e.clientY,
    });
  };
  const handleMove = (e) => {
    if (tooltip) setTooltip({ ...tooltip, x: e.clientX, y: e.clientY });
  };
  const handleLeave = () => setTooltip(null);

  return (
    <article className="card-dash card--venditeContatti">
      <div className="header--venditeContatti">
        <h3>Vendite Vs. Contatti</h3>
        <div className="conversione--venditeContatti">Conversione: {conversion}%</div>
        <select
          className="select--venditeContatti"
          value={months}
          onChange={(e) => setMonths(Number(e.target.value))}
        >
          <option value={6}>Ultimi 6 mesi</option>
          <option value={12}>Ultimi 12 mesi</option>
        </select>
      </div>
      <div className="chart--venditeContatti">
        <div className="chart-inner--venditeContatti">
          <div className="chart-grid--venditeContatti"></div>
          <div className="y-labels--venditeContatti">
            {labels.map((l, i) => (
              <span key={i}>{l}</span>
            ))}
          </div>
          <div
            className="bars--venditeContatti"
            style={{ gridTemplateColumns: `repeat(${data.length}, 1fr)` }}
          >
            {data.map((item) => (
              <div
                className="col--venditeContatti"
                key={item.month}
                onMouseEnter={(e) => handleEnter(e, item)}
                onMouseMove={handleMove}
                onMouseLeave={handleLeave}
              >
                <div
                  className="barA--venditeContatti"
                  style={{ height: `${item.contatti * scale}px` }}
                ></div>
                <div
                  className="barB--venditeContatti"
                  style={{ height: `${item.vendite * scale}px` }}
                ></div>
              </div>
            ))}
          </div>
          <div className="x-labels--venditeContatti">
            {data.map((item) => (
              <span key={item.month}>
                {monthLabels[Number(item.month.split('-')[1]) - 1]}
              </span>
            ))}
          </div>
          <div className="legend-row--venditeContatti">
            <span className="dotA--venditeContatti"></span>
            <span>Contatti</span>
            <span className="dotB--venditeContatti" style={{ marginLeft: 16 }}></span>
            <span>Vendite</span>
          </div>
        </div>
      </div>
      {tooltip && (
        <div
          className="chart-tooltip--venditeContatti"
          style={{ left: tooltip.x, top: tooltip.y }}
        >
          <div className="tt-title--venditeContatti">{tooltip.month}</div>
          <div className="tt-row--venditeContatti">
            <span className="tt-swatch--venditeContatti tt-a--venditeContatti"></span>
            Contatti: <strong>{tooltip.contatti}</strong>
          </div>
          <div className="tt-row--venditeContatti">
            <span className="tt-swatch--venditeContatti tt-b--venditeContatti"></span>
            Vendite: <strong>{tooltip.vendite}</strong>
          </div>
        </div>
      )}
    </article>
  );
}
